import { adminApi } from "./config";

export const getSupportNumbers = async()=>{
    return await adminApi.get('/support/support-numbers')
}